import { render, staticRenderFns } from "./Checkins.vue?vue&type=template&id=488f944f&scoped=true&"
import script from "./Checkins.vue?vue&type=script&lang=js&"
export * from "./Checkins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488f944f",
  null
  
)

export default component.exports